import { safeDefine } from "../../registration/safe-define.js";
import { PopoverElement } from "../../ui/popover/element.js";
//#region src/define/ui/popover.ts
safeDefine(PopoverElement);
//#endregion

//# sourceMappingURL=popover.js.map